import { keys, noop } from 'lodash';
import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config';
import { isCampaignGroupRealtimeVisible } from 'modules/campaigns/config/report-predicates/isCampaignGroupRealtimeVisible';
import { REPORT_PERMISSION } from 'modules/campaigns/config/reportPermissions';
import { BULK_ACTION } from 'modules/campaigns/modules/campaigns-reports/components/BulkActionToolbar/bulkAction';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { bulkEditCampaignsGroup } from '../../../flows';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { CAMPAIGNS_GROUPS_REALTIME_REPORT_ID } from './campaignGroupRealtimeReportId';
import columnDefinitions from './columnDefinitions';
import footerColumnDefinitions from './footerColumnDefinitions';
import { graph } from './graph';
import { defaultColumns, performanceColumns, setupColumns } from './reportPresets';

export const campaignsGroupRealtimeReportConfig = {
    id: CAMPAIGNS_GROUPS_REALTIME_REPORT_ID,
    label: 'Campaign Groups',
    accountConfigurations: {
        [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false',
    },
    permissions: [REPORT_PERMISSION.TA_CAMPAIGN_GROUP_REAL_TIME_REPORT],
    visibilityCondition: isCampaignGroupRealtimeVisible,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-group-realtime-report-by-campaign-group',
    graph,
    rowIdField: FIELDS.CAMPAIGNS_GROUP_ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
        [REPORT_PRESET.PERFORMANCE]: { columns: performanceColumns },
        [REPORT_PRESET.SETUP]: { columns: setupColumns },
    },
    footerColumnDef: footerColumnDefinitions,
    searchPlaceholderMsgId: 'app.reports.byCampaignsGroup.search.placeholder',
    searchField: FIELDS.CAMPAIGNS_GROUP_NAME.field,
    inlineEditPermissions: ['CAMPAIGN_EDIT', 'EDIT_CAMPAIGN_GROUP'],
    sortMap: {
        [FIELDS.BUDGET.field]: 'budget_limit',
    },
    initialFilters: [],
    filters: [{ id: FILTER_TYPE.CAMPAIGN_GROUP_STATUS, multiSelect: true, minVisibleCount: 4 }],
    bulkActions: [
        {
            key: BULK_ACTION.PLAY,
            //ToDo: implement play action handler
            handler: noop,
        },
        {
            key: BULK_ACTION.PAUSE,
            //ToDo: implement pause action handler
            handler: noop,
        },
        {
            key: BULK_ACTION.EDIT,
            handler:
                ({ selectedRows, accountName, navigate }) =>
                dispatch => {
                    dispatch(
                        bulkEditCampaignsGroup({
                            accountId: accountName,
                            selectedRowsIds: keys(selectedRows),
                            navigate,
                        })
                    );
                },
        },
    ],
};

export default campaignsGroupRealtimeReportConfig;
